import React from 'react';
import { Channel } from '../../types';
import { Hash, Lock } from 'lucide-react';
import { Avatar } from '../ui/Avatar';
import { Badge } from '../ui/Badge';
import { cn } from '../../lib/utils';

interface ChannelItemProps {
  channel: Channel;
  isSelected: boolean;
  onClick: () => void;
}

export const ChannelItem: React.FC<ChannelItemProps> = ({ 
  channel, 
  isSelected, 
  onClick 
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        "w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-colors group",
        isSelected 
          ? "bg-blue-50 text-blue-700 font-medium" 
          : "text-gray-700 hover:bg-gray-100 dark:bg-slate-800"
      )}
    >
      {channel.channelType === 'DIRECT' ? (
        <Avatar 
          userId={channel.id} 
          initials={(channel.name || '').substring(0, 2)} 
          size="sm" 
          className="w-5 h-5 text-[10px]"
        />
      ) : (
        <div className="relative">
          <Hash size={16} className={cn(
            "flex-shrink-0",
            isSelected ? "text-blue-700" : "text-gray-400 group-hover:text-gray-600"
          )} />
          {channel.isPrivate && (
            <div className="absolute -top-1 -right-1 bg-white rounded-full dark:bg-slate-900">
              <Lock size={8} className="text-gray-400" />
            </div>
          )}
        </div>
      )}
      
      <span className="truncate flex-1 text-left">{channel.name}</span>
      
      {channel.unreadCount > 0 && (
        <Badge variant="red" className="ml-auto px-1.5 py-0 min-w-[18px] h-[18px] flex items-center justify-center">
          {channel.unreadCount}
        </Badge>
      )}
    </button>
  );
};
